import Skinnyjeans from "../../images/circleIcons/3x/1-eyeglasses.png";
import Straws from "../../images/circleIcons/3x/2-InfantFormula.png";
import Spaghetti from "../../images/circleIcons/3x/3-WoodPellet.png";
import Iceland from "../../images/circleIcons/3x/6-ElectricScooter.png";
import Skateboard from "../../images/circleIcons/3x/7-IceCream.png";
import AlmondMilk from "../../images/circleIcons/3x/8-CrudeOil.png";
import bfastSandwich from "../../images/circleIcons/3x/4-Housing.png";
import Trashcan from "../../images/circleIcons/3x/9-Aluminium.png";
import CoffeeBeans from "../../images/circleIcons/3x/5-Chocolate.png";
import Astronaut from "../../images/circleIcons/3x/10-Printerpaper.png";

// chart title = title
// Breaking News = question
// question = subQuestion
// answer = briefness
const questionAnswers = [
  {
    title: "MARKET FOR EYE GLASSES",
    question:
      "Laser vision correction grows in popularity.",
    subQuestion: "Consider the market for prescription eye glasses. What happens?",
    icon: Skinnyjeans,
    answer: "Demand curve shifts left",
    graphType: "supply curve",
    briefness:
      "Laser vision correction is a substitute for wearing prescription glasses (for most users). If more users decide to get laser vision correction, demand for prescription eye glasses will decrease. Therefore, the demand curve will shift to the left.",
  },
  {
    title: "MARKET FOR INFANT FORMULA",
    question: "The U.S. birth rate increases for the first time in 6 years.",
    subQuestion: "Consider the market for infant formula. What happens?",
    icon: Straws,
    answer: "Demand curve shifts right",
    graphType: "supply curve",
    briefness:
      "An increase in the birth rate causes a rise in the population interested in purchasing infant formula. Therefore, the demand curve will shift to the right.",
  },

  {
    title: "MARKET FOR E.U. WOOD PELLETS",
    question: "The E.U. votes to remove a subsidy for wood pellets given to wood pellet producers.",
    subQuestion: "Consider the market for wood pellets in the E.U. What happens?",
    icon: Spaghetti,
    answer: "Supply curve shifts left",
    graphType: "supply curve",
    briefness:
      "Removing a subsidy is equivalent to increasing production costs (since the costs were previously lowered by a subsidy). An increase in production costs shifts the supply of wood pellets up and to the left.",
  },

  {
    title: "HOUSING MARKET FOR HIGH FALLS",
    question: "Average incomes for the town of High Falls have increased 15% in the last year.",
    subQuestion: "Consider the housing market (assume housing is a normal good) in High Falls. What happens?",
    icon: bfastSandwich,
    answer: "Demand curve shifts right",
    graphType: "supply curve",
    briefness:
      "When incomes increase, individuals are willing to pay more for their homes. Since incomes are increasing in High Falls, this increases demand for homes—shifting the demand curve to the right.",
  },

  {
    title: "MARKET FOR CHOCOLATE BARS",
    question: "Cocoa bean prices fall.",
    subQuestion: "Consider the market for chocolate bars. What happens?",
    icon: CoffeeBeans,
    answer: "Supply curve shifts right",
    graphType: "supply curve",
    briefness:
      "Cocoa beans are an input for chocolate bars. When input prices fall, suppliers are willing to supply more bars for the same price. The supply curve for chocolate bars will shift to the right.",
  },

  {
    title: "MARKET FOR ELECTRIC SCOOTERS",
    question: "News outlets report that a new electric scooter—with improved battery life and durability—is likely to hit the market within a year.",
    subQuestion: "Consider the current market for electric scooters. What happens?",
    icon: Iceland,
    answer: "Demand curve shifts left",
    graphType: "supply curve",
    briefness:
      "If consumers expect better electric scooters to be released at a later date, they will hold off purchasing scooters now. This will decrease current demand for electric scooters, and the demand curve will shift to the left.",
  },

  {
    title: "MARKET FOR ICE CREAM IN OMAHA",
    question:
      "Tourists swarm Times Square for the annual New Year's Eve party.",
    subQuestion: "Consider the market for ice cream in Omaha. What happens?",
    icon: Skateboard,
    answer: "Nothing happens",
    graphType: "supply curve",
    briefness:
      "This was a trick question. As far as we know, there is no relationship between tourists visiting Times Square for New Year's Eve and the market for ice cream in Omaha.",
  },

  {
    title: "MARKET FOR EUROPEAN CRUDE OIL",
    question:
      "A large container ship is wedged in the Suez Canal, forcing other container ships to reroute and sail around Africa, adding 15 days to their journey.",
    subQuestion: "Consider the market for European crude oil, commonly shipped via the Suez Canal. What happens?",
    icon: AlmondMilk,
    answer: "Supply curve shifts left",
    graphType: "supply curve",
    briefness:
      "A longer shipping route increases the cost—as well as the time required—to get oil to market. This increase in cost shifts the supply curve for oil to the left.",
  },

  {
    title: "MARKET FOR ALUMINUM",
    question:
      "Suppliers expect the price of aluminum to decline in the next 6 months.",
    subQuestion: "Consider the current market for aluminum. What happens?",
    icon: Trashcan,
    answer: "Supply curve shifts right",
    graphType: "supply curve",
    briefness:
      "If suppliers think they will get a lower price for aluminum in the future, they will want to sell more now—while prices are higher. This shifts the supply curve for aluminum to the right.",
  },

  {
    title: "MARKET FOR PRINTER PAPER",
    question: "Major retailers discount all printers at least 50% off.",
    subQuestion: "Consider the market for printer paper. What happens?",
    icon: Astronaut,
    answer: "Demand curve shifts right",
    graphType: "supply curve",
    briefness:
      "As the price of printers decreases, the quantity of printers demanded will increase. This will increase demand for printer paper—a complement. The demand curve for printer paper will shift to the right.",
  },
];

export default questionAnswers;
